import { APP_ID, NgModule } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";

import { AppComponent } from './app.component';
import { SpartacusCustomModule } from 'src/app/spartacus-custom.module';
import { SpartacusModule } from './spartacus/spartacus.module';
import {AppRoutingModule} from "@spartacus/storefront";
import {StoreModule} from "@ngrx/store";
import {EffectsModule} from "@ngrx/effects";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    SpartacusModule,
    SpartacusCustomModule,
  ],
  providers: [
    { provide: APP_ID, useValue: 'serverBarcelonaApp' },
    provideHttpClient(withFetch(),
    withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
